import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { SearchComponent } from './components';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
    ],
    declarations: [
        SearchComponent,
    ],
    exports: [
        SearchComponent,
    ],
})

export class SearchModule {}
